import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';
import { getSandboxQueryOptions } from '@/lib/queries/loop-planner/useGetSandbox';
import { isHttpError } from '@/lib/utils/common/isHttpError';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/')({
  loader: async ({ params: { loopId, org }, context: { queryClient } }) => {
    try {
      const sandbox = await queryClient.ensureQueryData(
        getSandboxQueryOptions({ loopId: Number(loopId) }),
      );
      if (sandbox) {
        throw redirect({
          to: '/org/$org/loop/$loopId/planner/sandbox/table',
          params: { org, loopId },
        });
      }
      return null;
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }
      if (isHttpError(error, 404)) {
        return null;
      }
      throw error;
    }
  },
});
